import * as yup from 'yup';

const userSchema = yup.object().shape(
  {
    name: yup.string().required('Full Name is required'),
    email: yup.string().when(['phoneNumber', '$useEmployeeId'], {
      is: (phoneNumber, useEmployeeId) =>
        !useEmployeeId && (!phoneNumber || phoneNumber.length === 0),
      then: yup
        .string()
        .email('Please enter a valid email')
        .required('Phone or Email is required'),
    }),
    phoneNumber: yup.string().when(['email', '$useEmployeeId'], {
      is: (email, useEmployeeId) =>
        !useEmployeeId && (!email || email.length === 0),
      then: yup.string().required('Phone or Email is required'),
    }),
    isAdmin: yup.boolean().required(),
    employeeId: yup.string().when('$useEmployeeId', {
      is: true,
      then: yup
        .string()
        .required('Employee ID is required when enabled for the board'),
      otherwise: yup.string().nullable(),
    }),
  },
  [['email', 'phoneNumber']],
);

export default userSchema;
